import React, { useContext, useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { logoWhite, logoDark, key } from "assets/images/image";
import { useLocation, Link } from "react-router-dom";
import { GlobalContext } from "context/Provider";
import ThemeToggle from "assets/theme/themetoggle";
import { useTheme } from "context/ThemeProvider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import WebFont from "webfontloader";
import { Grid } from "@mui/material";
import P from "components/Font/P";


function Header({ drawerWidth, handleDrawerToggle }) {
  return (
    <Box
      className="app-bar"
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        px: 3,
        py: 3
      }}
    >
      <Grid container>
        <Grid item xs={12} sm={12} md={6}>
          <Box sx={{ display: 'flex', alignItems: 'center', width: { lg: 400, md: '100%' }, height: { md: '100%' } }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <input className="search-input" placeholder="Search for collections and NFTs" />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { md: 'flex-end', xs: 'space-around' } }}>
            <Box sx={{ textAlign: 'center' }}>
              <P fontWeight={600}>2</P>
              <P fontWeight={600} color="third.disabledTextColor" uppercase fontSize={12}>Collections</P>
            </Box>
            <Box sx={{ textAlign: 'center', ml: { lg: 6, md: 3 } }}>
              <P fontWeight={600}>6632</P>
              <P fontWeight={600} color="third.disabledTextColor" uppercase fontSize={12}>Sales</P>
            </Box>
            <Box sx={{ textAlign: 'center', ml: { lg: 6, md: 3 } }}>
              <P fontWeight={600}>431.49K</P>
              <P fontWeight={600} color="third.disabledTextColor" uppercase fontSize={12}>Volume</P>
            </Box>
            <ThemeToggle />
          </Box>
        </Grid>
      </Grid>

    </Box>
  );
}

export default Header;
